import React from 'react'
import * as R from 'ramda'

const cache = new Map()

const lookupService = variables => ({
  search(query, callback) {
    window.setTimeout(() => {
      const results = R.filter(
        ({ label }) => R.pipe(R.toLower, R.includes(R.toLower(query)))(label),
        variables,
      )
      callback(results)
    }, 500)
  },
})

export const useVariableLookup = (query, variables) => {
  const [results, setResults] = React.useState([])

  const prevVariables = React.useRef(variables)

  React.useEffect(() => {
    if (prevVariables.current !== variables) {
      cache.clear()
    }
  }, [prevVariables, variables])

  React.useEffect(() => {
    const cachedResults = cache.get(query)

    if (query == null) {
      setResults([])
      return
    }

    if (cachedResults === null) {
      return
    } else if (cachedResults !== undefined) {
      setResults(cachedResults)
      return
    }

    cache.set(query, null)

    lookupService(variables).search(query, newResults => {
      cache.set(query, newResults)
      setResults(newResults)
    })
  }, [prevVariables, query, variables, setResults])

  return results
}
